import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BadgeComponent } from '../../badge/badge.component';
import { BadgeColor } from '../../badge/badge.types';
import { DotComponent } from '../../dot/dot.component';
import { TypeofPipe } from '../../pipes/typeof.pipe';

@Component({
  selector: 'rt-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.disabled]': 'disabled',
  },
  standalone: true,
  imports: [DotComponent, BadgeComponent, TypeofPipe],
})
export class TabComponent {
  @Input() public isUnread: boolean = false;
  @Input() public count: number | string = 0;
  @Input() public countColor: BadgeColor = 'counter-default';
  @Input() public href: string;
  @Input() public hrefTarget: string;
  @Input() public disabled: boolean = false;
  @Input() public noRightPadding: boolean = false;
}
